import React from "react";
import "./ConfirmationModal.scss";

const ConfirmationModal = ({
  show,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = "Confirm",
  cancelText = "Cancel",
}) => {
  if (!show) {
    return null;
  }

  return (
    <div className="confirmation-overlay">
      <div className="confirmation-box">
        <h3>{title}</h3>
        <p>{message}</p>
        <div className="confirmation-buttons">
          <button onClick={onCancel} className="secondary-btn">
            {cancelText}
          </button>
          <button onClick={onConfirm} className="primary-btn">
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
